import { useState, useEffect } from "react";
import { Flame, X } from "lucide-react";

export default function StreakNudge() {
  const [visible, setVisible] = useState(false);
  const [streak, setStreak] = useState(0);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("afford_streak") || '{"count":0,"lastVisit":""}');
    const today = new Date().toDateString();
    const lastVisit = data.lastVisit;

    if (lastVisit === today) {
      setStreak(data.count);
      return;
    }

    const yesterday = new Date(Date.now() - 86400000).toDateString();
    let newCount = lastVisit === yesterday ? data.count + 1 : 1;
    
    localStorage.setItem("afford_streak", JSON.stringify({ count: newCount, lastVisit: today }));
    setStreak(newCount);

    if (newCount > 1) {
      setTimeout(() => setVisible(true), 2000);
    }
  }, []);

  if (!visible || streak <= 1) return null;

  return (
    <div className="fixed top-20 right-4 z-40 bg-white border border-amber-200 rounded-xl shadow-lg p-4 max-w-[260px] animate-in fade-in slide-in-from-right" data-testid="streak-nudge">
      <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
          <Flame className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-900">{streak}-day streak!</p>
          <p className="text-xs text-slate-500">Keep exploring cities</p>
        </div>
      </div>
    </div>
  );
}
